"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostTabsContext = void 0;
var react_1 = require("react");
exports.PostTabsContext = react_1.createContext({});
